import { Center, Tooltip } from '@chakra-ui/react'
import { ScreenShareOn } from 'src/components/icon'

import { useLocalPlayer } from '../../context/localPlayerContext'
import {
  ControlButtonType,
  getButtonSize,
  getIconSize,
} from '../../utils/controlButtonUtil'
import { isScreenShareSupported } from '../../utils/isScreenShareSupported'

type Props = {
  type?: ControlButtonType
  colorScheme?: 'blue' | 'green'
}

export const ScreenShareButton: React.FC<Props> = ({
  type = 'normal',
  colorScheme = 'blue',
}) => {
  const { localScreenEnabled, startLocalScreen, stopLocalScreen } =
    useLocalPlayer()

  const buttonSize = getButtonSize(type)
  const iconSize = getIconSize(type)

  const tooltipLabel = localScreenEnabled ? '画面共有を終了' : '画面共有を開始'

  if (!isScreenShareSupported) {
    return null
  }

  return (
    <Tooltip label={tooltipLabel}>
      <Center
        as="button"
        borderRadius="full"
        aria-label={localScreenEnabled ? '画面共有を終了' : '画面共有を開始'}
        bg={localScreenEnabled ? `${colorScheme}.500` : 'white'}
        _hover={{
          bg: localScreenEnabled ? `${colorScheme}.600` : 'gray.50',
        }}
        _active={{
          bg: localScreenEnabled ? `${colorScheme}.700` : 'gray.100',
        }}
        border={localScreenEnabled ? 'none' : '2px solid'}
        borderColor={`${colorScheme}.500`}
        color={localScreenEnabled ? 'white' : `${colorScheme}.500`}
        w={buttonSize}
        h={buttonSize}
        onClick={localScreenEnabled ? stopLocalScreen : startLocalScreen}
      >
        <ScreenShareOn size={iconSize} />
      </Center>
    </Tooltip>
  )
}
